var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',{staticClass:"level-desing level-badge",class:_vm.toneClass},[_vm._v(_vm._s(_vm.level))])
}
var staticRenderFns = []

export { render, staticRenderFns }